"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Padder extends React.PureComponent {
    render() {
        return React.createElement("div", { style: { display: 'flex', flex: 1 } });
    }
}
exports.Padder = Padder;
